export default __webpack_public_path__ + "static/media/icon-web_browser.c5bc1012.svg";